import { Component, OnInit } from '@angular/core';
import { HttpService } from '../service/http.service';
import { TravelType } from '../travel-type';

@Component({
  selector: 'app-travels',
  templateUrl: './travels.component.html',
  styleUrls: ['./travels.component.css']
})
export class TravelsComponent implements OnInit {

  travelTypes: TravelType[] = [];

  constructor(
    private httpService: HttpService,

  ) { }

  ngOnInit(): void {
    this.httpService.getTravelTypes().subscribe(res => {
      this.travelTypes = res;
    });
  }

}
